import React, { useState, useEffect, useRef } from 'react';
import { useApp } from '../../context/AppContext';
import PaiementSurDevis from '../payment/PaiementSurDevis';
import './Contact.css';

export default function Contact({ prefilledService = '', prefilledMessage = '' }) {
  const { data, showToast } = useApp();
  const c = data.contact;
  const [submitted,    setSubmitted]    = useState(false);
  const [showPaiement, setShowPaiement] = useState(false);
  const [serviceVal,   setServiceVal]   = useState('');
  const [messageVal,   setMessageVal]   = useState('');
  const formRef = useRef(null);

  // Pré-remplissage depuis Digitalisation ou autre section
  useEffect(() => {
    if (prefilledService) {
      setServiceVal(prefilledService);
      setMessageVal(prefilledMessage || '');
      // Scroll vers le formulaire
      setTimeout(() => {
        formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 100);
    }
  }, [prefilledService, prefilledMessage]);

  function handleSubmit(e) {
    e.preventDefault();
    const form = e.target;
    const nom     = form.querySelector('[name="nom"]')?.value     || '';
    const tel     = form.querySelector('[name="tel"]')?.value     || '';
    const email   = form.querySelector('[name="email"]')?.value   || '';
    const service = serviceVal || form.querySelector('[name="service"]')?.value || '';
    const message = messageVal || form.querySelector('[name="message"]')?.value || '';

    // Construire le lien mailto
    const sujet  = encodeURIComponent(`[KOTOSTECHNOLOGY] Demande — ${service || 'Projet'}`);
    const corps  = encodeURIComponent(
      `Nom : ${nom}\nTéléphone : ${tel}\nEmail : ${email}\n\nService souhaité : ${service}\n\nMessage :\n${message}`
    );
    window.location.href = `mailto:${c.email}?subject=${sujet}&body=${corps}`;

    setSubmitted(true);
    showToast('Redirection vers votre messagerie... ✓', 'ok');
    setTimeout(() => {
      setSubmitted(false);
      setServiceVal('');
      setMessageVal('');
      form.reset();
    }, 3000);
  }

  // Liste des services — incluant Digitalisation
  const services = [
    ...data.domaines.map(d => d.name),
    ...data.formations.map(f => 'Formation: ' + f.title),
    ...(data.produits || []).filter(p => p.active !== false).map(p => 'Application: ' + p.name),
    // ── Packs Digitalisation ──
    ...((data.digitalisation?.secteurs || []).flatMap(s =>
      s.packs.map(p => `Digitalisation ${s.name} — Pack ${p.name}`)
    )),
    ...(data.pipeline || []).map(p => 'À venir: ' + p.name),
    'Autre / Prestation sur mesure',
  ];

  return (
    <section className="ms" id="contact">
      <div className="sh">
        <div className="stag">Contact &amp; Paiement</div>
        <h2 className="stitle">Parlons de Votre Projet</h2>
      </div>

      {/* Paiement box */}
      <div className="pay-box">
        <div className="pay-item">
          <div style={{ fontSize: 22 }}>📱</div>
          <div>
            <div className="pay-lbl">Mobile Money</div>
            <div className="pay-val">{data.paiement.mobile}</div>
          </div>
        </div>
        <div className="pay-item">
          <div style={{ fontSize: 22 }}>🏦</div>
          <div>
            <div className="pay-lbl">Virement Bancaire</div>
            <div className="pay-val">{data.paiement.bank?.split('\n')[0]}</div>
          </div>
        </div>
      </div>

      <div style={{ textAlign: 'center', marginBottom: 40 }}>
        <button
          onClick={() => setShowPaiement(true)}
          style={{
            background: 'linear-gradient(135deg, #00aa55, #00CC88)', color: '#050810',
            border: 'none', borderRadius: 10, padding: '13px 26px', fontWeight: 800,
            fontSize: 14, cursor: 'pointer',
          }}
        >
          💳 Payer une prestation sur mesure / un devis reçu
        </button>
      </div>

      {showPaiement && <PaiementSurDevis onClose={() => setShowPaiement(false)} />}

      <div className="cwrap">
        {/* Infos contact */}
        <div className="cinfo">
          <h3>📡 CONTACTEZ-NOUS</h3>
          <div className="ci"><div className="ci-icon">📞</div><div><h4>Téléphone/WhatsApp</h4><p>{c.tel}</p></div></div>
          <div className="ci"><div className="ci-icon">📧</div><div><h4>Email</h4>
            <p><a href={`mailto:${c.email}`}>{c.email}</a></p>
            {c.email2 && <p><a href={`mailto:${c.email2}`}>{c.email2}</a></p>}
          </div></div>
          <div className="ci"><div className="ci-icon">🌐</div><div><h4>Site web</h4>
            <p><a href="https://www.kotostechnology.com" target="_blank" rel="noreferrer">www.kotostechnology.com</a></p>
          </div></div>
          <div className="ci"><div className="ci-icon">📍</div><div><h4>Adresse</h4><p>{c.address}</p></div></div>
          <div className="ci"><div className="ci-icon">🕒</div><div><h4>Horaires</h4><p>{c.hours}</p></div></div>
          <div className="rccm-box">
            <p>REGISTRE DE COMMERCE N° {c.rccm}<br/>
            DELIVRE A {c.rccmVille} – RAISON SOCIALE: {c.raison}<br/>
            N° IFU: {c.ifu} · {c.email} · {c.address}</p>
          </div>
        </div>

        {/* Formulaire */}
        <form className="cform" onSubmit={handleSubmit} ref={formRef}>

          {/* Bandeau si pré-rempli depuis Digitalisation */}
          {(serviceVal || prefilledService) && (
  <div style={{
    background: (serviceVal || prefilledService).startsWith('Digitalisation')
      ? 'rgba(155,89,182,0.12)' : 'rgba(0,191,255,0.08)',
    border: `1px solid ${(serviceVal || prefilledService).startsWith('Digitalisation')
      ? 'rgba(155,89,182,0.4)' : 'rgba(0,191,255,0.3)'}`,
    borderRadius: '10px', padding: '12px 16px',
    marginBottom: '16px', fontSize: '13px',
    color: (serviceVal || prefilledService).startsWith('Digitalisation')
      ? '#CC88FF' : '#00BFFF',
    fontWeight: 700,
    display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap'
  }}>
    {(serviceVal || prefilledService).startsWith('Digitalisation')
      ? '🌐 Demande de devis —'
      : (serviceVal || prefilledService).startsWith('Formation:')
      ? '📚 Demande de formation —'
      : (serviceVal || prefilledService).startsWith('Application:')
      ? '💻 Demande d\'information —'
      : (serviceVal || prefilledService).startsWith('À venir:')
      ? '🚀 Pré-inscription —'
      : (serviceVal || prefilledService) === 'Autre / Prestation sur mesure'
      ? '🛠 Prestation sur mesure —'
      : '📋 Demande concernant —'
    }
    <span style={{color:'#fff'}}>
      {serviceVal || prefilledService}
    </span>
  </div>
)}

          <div className="fr">
            <div className="fg">
              <label>Nom *</label>
              <input name="nom" type="text" placeholder="Votre nom" required />
            </div>
            <div className="fg">
              <label>Téléphone *</label>
              <input name="tel" type="tel" placeholder="+229 XX XX XX" required />
            </div>
          </div>

          <div className="fg">
            <label>Email</label>
            <input name="email" type="email" placeholder="votre@email.com" />
          </div>

          <div className="fg">
            <label>Service souhaité</label>
            <select
              name="service"
              value={serviceVal}
              onChange={e => {
  const val = e.target.value;
  setServiceVal(val);

  if (!val) { setMessageVal(''); return; }

  if (val.startsWith('Digitalisation')) {
    // Chercher le vrai pack dans data.digitalisation
    let secteurTrouve = null;
    let packTrouve    = null;

    for (const s of (data.digitalisation?.secteurs || [])) {
      for (const p of s.packs) {
        const label = `Digitalisation ${s.name} — Pack ${p.name}`;
        if (label === val) {
          secteurTrouve = s;
          packTrouve    = p;
          break;
        }
      }
      if (packTrouve) break;
    }

    if (secteurTrouve && packTrouve) {
      // Formater les prix selon la devise courante (FCFA par défaut)
      const prixInstall  = packTrouve.prixFcfa
        ? new Intl.NumberFormat('fr-FR').format(packTrouve.prixFcfa) + ' FCFA'
        : 'Sur devis';
      const prixEntretien = packTrouve.entretienActif && packTrouve.entretienFcfa
        ? new Intl.NumberFormat('fr-FR').format(packTrouve.entretienFcfa) + ' FCFA/mois'
        : null;

      setMessageVal(
        `Bonjour,\n\nJe souhaite obtenir un devis pour :\n\n` +
        `🌐 Secteur : ${secteurTrouve.name}\n` +
        `📦 Pack : ${packTrouve.name}\n` +
        `💰 Prix installation : ${prixInstall}\n` +
        (prixEntretien ? `🔧 Entretien mensuel : ${prixEntretien}\n` : '') +
        `\n✅ Ce pack inclut :\n` +
        (packTrouve.inclus || []).map(i => `  • ${i}`).join('\n') +
        `\n\nInformations complémentaires :\n` +
        `- Nombre d'utilisateurs prévus : \n` +
        `- Délai de mise en place souhaité : \n` +
        `- Questions spécifiques : \n` +
        `\nMerci de me contacter pour finaliser ce devis.\n\nCordialement.`
      );
    }

  } else if (val.startsWith('Formation:')) {
    const titre = val.replace('Formation: ', '');
    const form  = data.formations.find(f => f.title === titre);
    setMessageVal(
      `Bonjour,\n\nJe suis intéressé(e) par la formation :\n📚 ${titre}\n` +
      (form ? `⏱ Durée : ${form.duree} · 👥 ${form.places} · 📍 ${form.mode}\n💰 Tarif : ${form.price} ${form.currency}\n` : '') +
      `\nInformations :\n- Nombre de participants : \n- Disponibilités : \n` +
      `\nMerci de m'envoyer les détails.\n\nCordialement.`
    );

  } else if (val.startsWith('Application:')) {
    const nom = val.replace('Application: ', '');
    const app = (data.produits || []).find(p => p.name === nom);
    setMessageVal(
      `Bonjour,\n\nJe souhaite en savoir plus sur :\n💻 ${nom}\n` +
      (app && !app.onDevis
        ? `💰 Tarif : ${new Intl.NumberFormat('fr-FR').format(app.priceFcfa)} FCFA/${app.unit}\n`
        : app?.onDevis ? `💰 Tarif : Sur devis\n` : '') +
      (app?.longDesc ? `\n📋 ${app.longDesc}\n` : '') +
      `\nInformations :\n- Secteur d'activité : \n- Nombre d'utilisateurs : \n` +
      `\nMerci de me contacter pour une démonstration.\n\nCordialement.`
    );

  } else if (val.startsWith('À venir:')) {
    const nom = val.replace('À venir: ', '');
    const pip = (data.pipeline || []).find(p => p.name === nom);
    setMessageVal(
      `Bonjour,\n\nJe suis intéressé(e) par votre application en développement :\n🚀 ${nom}\n` +
      (pip?.statut ? `📌 Statut : ${pip.statut}\n` : '') +
      `\nMerci de me tenir informé(e) dès sa disponibilité.\n\nCordialement.`
    );

  } else if (val === 'Autre / Prestation sur mesure') {
    setMessageVal(
      `Bonjour,\n\nJe souhaite vous soumettre un besoin spécifique :\n\n` +
      `📋 Description du projet :\n[Décrivez votre besoin ici]\n\n` +
      `💰 Budget envisagé : \n📅 Délai souhaité : \n👥 Nombre d'utilisateurs : \n` +
      `\nMerci de me contacter.\n\nCordialement.`
    );

  } else {
    // Domaine standard
    const domaine = data.domaines.find(d => d.name === val);
    setMessageVal(
      `Bonjour,\n\nJe suis intéressé(e) par vos services :\n🏢 ${val}\n` +
      (domaine?.price ? `💰 À partir de : ${domaine.price}\n` : '') +
      (domaine?.services?.length
        ? `\n📋 Services disponibles :\n${domaine.services.map(s => `  • ${s}`).join('\n')}\n`
        : '') +
      `\nDétails de mon projet :\n- Description : \n- Budget : \n- Délai : \n` +
      `\nMerci de me contacter.\n\nCordialement.`
    );
  }
}}
>
            
              <option value="">Sélectionner...</option>
              {/* Groupe Digitalisation en premier si pré-rempli */}
              {prefilledService && (
                <optgroup label="🌐 Digitalisation">
                  {(data.digitalisation?.secteurs || []).flatMap(s =>
                    s.packs.map(p => (
                      <option key={`${s.id}-${p.id}`} value={`Digitalisation ${s.name} — Pack ${p.name}`}>
                        {s.icon} {s.name} — Pack {p.name}
                      </option>
                    ))
                  )}
                </optgroup>
              )}
              <optgroup label="🏢 Nos domaines">
                {data.domaines.map(d => (
                  <option key={d.id} value={d.name}>{d.icon} {d.name}</option>
                ))}
              </optgroup>
              <optgroup label="📚 Formations">
                {data.formations.map(f => (
                  <option key={f.id} value={`Formation: ${f.title}`}>{f.icon} {f.title}</option>
                ))}
              </optgroup>
              <optgroup label="💻 Applications">
                {(data.produits || []).filter(p => p.active !== false).map(p => (
                  <option key={p.id} value={`Application: ${p.name}`}>{p.icon} {p.name}</option>
                ))}
              </optgroup>
              {!prefilledService && (
                <optgroup label="🌐 Digitalisation">
                  {(data.digitalisation?.secteurs || []).flatMap(s =>
                    s.packs.map(p => (
                      <option key={`${s.id}-${p.id}`} value={`Digitalisation ${s.name} — Pack ${p.name}`}>
                        {s.icon} {s.name} — Pack {p.name}
                      </option>
                    ))
                  )}
                </optgroup>
              )}
              <option value="Autre / Prestation sur mesure">🛠 Autre / Prestation sur mesure</option>
            </select>
          </div>

          <div className="fg">
            <label>Message *</label>
            <textarea
              name="message"
              placeholder="Décrivez votre projet..."
              required
              value={messageVal}
              onChange={e => setMessageVal(e.target.value)}
              rows={5}
            />
          </div>

          <button
            type="submit"
            className="btn btn-blue"
            style={{
              border: 'none', justifyContent: 'center', width: '100%', fontSize: 13,
              ...(submitted ? { background: 'linear-gradient(135deg,#00aa55,#00ff88)' } : {})
            }}
          >
            {submitted ? '✓ Redirection messagerie...' : 'Envoyer →'}
          </button>

          <p style={{
            fontSize: '11px', color: 'var(--muted)',
            textAlign: 'center', marginTop: '8px'
          }}>
            Votre demande sera envoyée à {c.email} — réponse sous 24h ouvrables.
          </p>
        </form>
      </div>
    </section>
  );
}